"use client";

import React, { createContext } from "react";
import type { Nullable } from "../../@types/generic";
import type { Dayjs as DayjsType } from "../../app/common/setupDayjs";

export const DayjsContext = createContext<
    Nullable<{
        locale: Promise<ILocale> | ILocale;
    }>
>(null);

export const DayjsProvider: React.FC<{
    children: React.ReactNode;
    locale: Promise<ILocale> | ILocale;
}> = ({ children, locale }) => {
    return (
        <DayjsContext.Provider value={{ locale }}>
            {children}
        </DayjsContext.Provider>
    );
};

export type Dayjs = DayjsType;
